export const color = {
    textGrey: '#868684'
}